const headerMenuPanel = $('#main-menu');
const topMenu = $('.top-menu');
const langs = $('.lang-switcher');

function adaptive_content(w) {
    $('.js-append').remove();

    if (w < 980) {
        let cloneTm = topMenu.clone();
        let cloneLangs = langs.clone();

        headerMenuPanel
            .append(cloneTm.addClass('js-append'))
            .prepend(cloneLangs.addClass('js-append'));
    }
}

function run() {
    adaptive_content($(window).outerWidth());
}

$(window).on('resize', run);
run();